import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { Flex } from "@redotech/redo-web/flex";
import LeftArrow from "@redotech/redo-web/icon-old/left-arrow.svg";
import { Text } from "@redotech/redo-web/text";
import * as classNames from "classnames";
import { memo } from "react";
import { useDocumentTitle } from "usehooks-ts";
import { getHeaderText } from "./dynamic-text-utils";
import { Gift } from "./gift";
import { OneTimePasscode } from "./one-time-passcode";
import * as page from "./page.module.css";
import { PortalDisabled } from "./portal-disabled";
import { Register } from "./register";
import { RegisterOtp } from "./register-otp";
import { SingleOrderLogin } from "./single-order-login";
import { LoginPage, useLogin } from "./use-login";
export const Login = memo(function Login() {
  const {
    settings,
    isPortalDisabled,
    currentPage,
    purchaseChannel,
    giftButtonClicked,
    registerButtonClicked,
    zipcodeButtonClicked,
    toOnlineRegistration,
    toRetailRegistration,
    onBackGiftClicked,
    onBackZipcodeClicked,
    onBackRegisterClicked,
    onBackRegisterOtpClicked,
    isMobile,
    errorMessage,
  } = useLogin();

  useDocumentTitle(getHeaderText(settings));

  return (
    <Flex
      align="center"
      className={page.page}
      flex={1}
      flexDirection="column"
      id="page"
      justify="center"
      p="xxs"
      position="relative"
      style={{
        backgroundImage: `url('${settings?.theme.background_image}')`,
        backgroundPosition: "center",
        backgroundColor: "#F8F8F8",
      }}
    >
      {isPortalDisabled ? (
        <PortalDisabled color={settings?.theme.home_text_color || "#fff"} />
      ) : (
        <Flex
          bgColor="primary"
          flexDirection="column"
          gap="3xl"
          justify="flex-start"
          m="sm"
          maxW={isMobile ? "full" : "none"}
          minW={isMobile ? "none" : "sm"}
          mt={currentPage === LoginPage.GIFT ? "8xl" : "none"}
          p="4xl"
          radius="md"
        >
          {currentPage === LoginPage.GIFT && (
            <Gift onBack={onBackGiftClicked} />
          )}
          {currentPage === LoginPage.ONE_TIME_PASSCODE && (
            <OneTimePasscode
              giftButtonClicked={giftButtonClicked}
              registerButtonClicked={registerButtonClicked}
              showFooter
              showLogo
              zipcodeLoginClicked={zipcodeButtonClicked}
            />
          )}
          {currentPage === LoginPage.SINGLE_ORDER && (
            <SingleOrderLogin
              giftButtonClicked={giftButtonClicked}
              onBack={onBackZipcodeClicked}
            />
          )}
          {currentPage === LoginPage.REGISTER && (
            <Register
              onBack={onBackRegisterClicked}
              toOnlineRegistration={toOnlineRegistration}
              toRetailRegistration={toRetailRegistration}
            />
          )}
          {currentPage === LoginPage.REGISTER_OTP && (
            <RegisterOtp
              onBack={onBackRegisterOtpClicked}
              purchaseChannel={purchaseChannel}
            />
          )}
          {errorMessage && (
            <Text textAlign="center" textColor="error">
              {errorMessage}
            </Text>
          )}
        </Flex>
      )}

      <StoreReturn className={page.storeReturnBlock} settings={settings} />
    </Flex>
  );
});

const StoreReturn = memo(function StoreReturn({
  className = "",
  settings,
}: {
  className?: string;
  settings?: ReturnAppSettings;
}) {
  return (
    <a
      className={classNames(className, page.storeReturn)}
      href={settings?.storeUrl ? "https://" + settings.storeUrl : ""}
      style={{ color: settings?.theme.home_text_color || "#fff" }}
    >
      {/*todo change the color of this conditionally*/}
      <LeftArrow />
      <div>Back to store</div>
    </a>
  );
});
